/**
 * @generated SignedSource<<584da552f4a7e750ccaee36436a7e251>>
 * @relayHash 4a8ec6c390bbf465413220e447725237
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 03ac59e734c379bd6d7d444c893fe2f990c1981ef4014a0337e3564cb1a0944b

var node = function () {
  var v0 = [{
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    }, {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "helpCenterAri"
    }],
    v1 = [{
      "kind": "Variable",
      "name": "cloudId",
      "variableName": "cloudId"
    }],
    v2 = [{
      "kind": "Variable",
      "name": "helpCenterAri",
      "variableName": "helpCenterAri"
    }],
    v3 = {
      "kind": "ScalarField",
      "name": "__typename"
    },
    v4 = {
      "kind": "InlineFragment",
      "selections": [{
        "kind": "ScalarField",
        "name": "hoistedProjectKey"
      }],
      "type": "HelpCenter"
    },
    v5 = {
      "args": [{
        "items": [{
          "kind": "Variable",
          "name": "cloudIds.0",
          "variableName": "cloudId"
        }],
        "kind": "ListValue",
        "name": "cloudIds"
      }],
      "concreteType": "TenantContext",
      "kind": "LinkedField",
      "name": "tenantContexts",
      "plural": true,
      "selections": [{
        "kind": "ScalarField",
        "name": "cloudUrl"
      }]
    };
  return {
    "fragment": {
      "argumentDefinitions": v0 /*: any*/,
      "kind": "Fragment",
      "name": "customizeAiMessageQuery",
      "selections": [{
        "args": v1 /*: any*/,
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [{
          "args": v2 /*: any*/,
          "kind": "LinkedField",
          "name": "helpCenterById",
          "plural": false,
          "selections": [v3 /*: any*/, v4 /*: any*/]
        }]
      }, v5 /*: any*/],
      "type": "Query"
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0 /*: any*/,
      "kind": "Operation",
      "name": "customizeAiMessageQuery",
      "selections": [{
        "args": v1 /*: any*/,
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [{
          "args": v2 /*: any*/,
          "kind": "LinkedField",
          "name": "helpCenterById",
          "plural": false,
          "selections": [v3 /*: any*/, v4 /*: any*/, {
            "kind": "InlineFragment",
            "selections": [{
              "kind": "ScalarField",
              "name": "id"
            }],
            "type": "Node",
            "abstractKey": "__isNode"
          }]
        }]
      }, v5 /*: any*/]
    },
    "params": {
      "id": "03ac59e734c379bd6d7d444c893fe2f990c1981ef4014a0337e3564cb1a0944b",
      "metadata": {},
      "name": "customizeAiMessageQuery",
      "operationKind": "query",
      "text": null
    }
  };
}();
node.hash = "5ae70602a5d54744676603e433196bd7";
export default node;